import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PodService {
  storedPo: any;

  constructor(private http: HttpClient) {}

  storePo(po: any) {
    this.storedPo = po;
    localStorage.setItem("storedPo", JSON.stringify(po));
  }

  getStoredPo() {
    const storedPo = localStorage.getItem("storedPo");
    if (storedPo) {
      this.storedPo = JSON.parse(storedPo);
    }
    return this.storedPo;
  }

  // Add your service methods here
}
